module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8ce26a259215de2c699199157d439b2f.png";